import {
  addAdminProductTypes,
  addProductModels,
  addProductModelsImages,
  addProductModelsVariants,
  deleteAdminProductTypesById,
  deleteProductModelsById,
  deleteProductModelsImagesById,
  deleteProductModelsVariantsById,
  downloadModelVariants,
  getAdminProductTypes,
  getAdminProductTypesById,
  getProductModels,
  getProductModelsById,
  getProductModelsFilterOptions,
  getProductModelsImages,
  getProductModelsVariants,
  updateAdminProductTypesById,
  updateProductModelsById,
  updateProductModelsVariantsById,
} from '../utils/requests/productModelsAPI'

export const LOAD_PRODUCT_MODELS_FILTER_OPTIONS = 'LOAD_PRODUCT_MODELS_FILTER_OPTIONS'
export const LOAD_PRODUCT_MODELS_FILTER_OPTIONS_PENDING = 'LOAD_PRODUCT_MODELS_FILTER_OPTIONS_PENDING'
export const LOAD_PRODUCT_MODELS_FILTER_OPTIONS_FULFILLED = 'LOAD_PRODUCT_MODELS_FILTER_OPTIONS_FULFILLED'
export const LOAD_PRODUCT_MODELS_FILTER_OPTIONS_REJECTED = 'LOAD_PRODUCT_MODELS_FILTER_OPTIONS_REJECTED'

export const LOAD_PRODUCT_MODELS_VARIANTS = 'LOAD_PRODUCT_MODELS_VARIANTS'
export const LOAD_PRODUCT_MODELS_VARIANTS_PENDING = 'LOAD_PRODUCT_MODELS_VARIANTS_PENDING'
export const LOAD_PRODUCT_MODELS_VARIANTS_FULFILLED = 'LOAD_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const LOAD_PRODUCT_MODELS_VARIANTS_REJECTED = 'LOAD_PRODUCT_MODELS_VARIANTS_REJECTED'

export const LOAD_NEW_PRODUCT_MODELS_VARIANTS = 'LOAD_NEW_PRODUCT_MODELS_VARIANTS'
export const LOAD_NEW_PRODUCT_MODELS_VARIANTS_PENDING = 'LOAD_NEW_PRODUCT_MODELS_VARIANTS_PENDING'
export const LOAD_NEW_PRODUCT_MODELS_VARIANTS_FULFILLED = 'LOAD_NEW_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const LOAD_NEW_PRODUCT_MODELS_VARIANTS_REJECTED = 'LOAD_NEW_PRODUCT_MODELS_VARIANTS_REJECTED'

export const POST_PRODUCT_MODELS_VARIANTS = 'POST_PRODUCT_MODELS_VARIANTS'
export const POST_PRODUCT_MODELS_VARIANTS_PENDING = 'POST_PRODUCT_MODELS_VARIANTS_PENDING'
export const POST_PRODUCT_MODELS_VARIANTS_FULFILLED = 'POST_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const POST_PRODUCT_MODELS_VARIANTS_REJECTED = 'POST_PRODUCT_MODELS_VARIANTS_REJECTED'

export const PUT_PRODUCT_MODELS_VARIANTS = 'PUT_PRODUCT_MODELS_VARIANTS'
export const PUT_PRODUCT_MODELS_VARIANTS_PENDING = 'PUT_PRODUCT_MODELS_VARIANTS_PENDING'
export const PUT_PRODUCT_MODELS_VARIANTS_FULFILLED = 'PUT_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const PUT_PRODUCT_MODELS_VARIANTS_REJECTED = 'PUT_PRODUCT_MODELS_VARIANTS_REJECTED'

export const DELETE_PRODUCT_MODELS_VARIANTS = 'DELETE_PRODUCT_MODELS_VARIANTS'
export const DELETE_PRODUCT_MODELS_VARIANTS_PENDING = 'DELETE_PRODUCT_MODELS_VARIANTS_PENDING'
export const DELETE_PRODUCT_MODELS_VARIANTS_FULFILLED = 'DELETE_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const DELETE_PRODUCT_MODELS_VARIANTS_REJECTED = 'DELETE_PRODUCT_MODELS_VARIANTS_REJECTED'

export const DOWNLOAD_PRODUCT_MODELS_VARIANTS = 'DOWNLOAD_PRODUCT_MODELS_VARIANTS'
export const DOWNLOAD_PRODUCT_MODELS_VARIANTS_PENDING = 'DOWNLOAD_PRODUCT_MODELS_VARIANTS_PENDING'
export const DOWNLOAD_PRODUCT_MODELS_VARIANTS_FULFILLED = 'DOWNLOAD_PRODUCT_MODELS_VARIANTS_FULFILLED'
export const DOWNLOAD_PRODUCT_MODELS_VARIANTS_REJECTED = 'DOWNLOAD_PRODUCT_MODELS_VARIANTS_REJECTED'

export const LOAD_PRODUCT_MODELS = 'LOAD_PRODUCT_MODELS'
export const LOAD_PRODUCT_MODELS_PENDING = 'LOAD_PRODUCT_MODELS_PENDING'
export const LOAD_PRODUCT_MODELS_FULFILLED = 'LOAD_PRODUCT_MODELS_FULFILLED'
export const LOAD_PRODUCT_MODELS_REJECTED = 'LOAD_PRODUCT_MODELS_REJECTED'

export const LOAD_NEW_PRODUCT_MODELS = 'LOAD_NEW_PRODUCT_MODELS'
export const LOAD_NEW_PRODUCT_MODELS_PENDING = 'LOAD_NEW_PRODUCT_MODELS_PENDING'
export const LOAD_NEW_PRODUCT_MODELS_FULFILLED = 'LOAD_NEW_PRODUCT_MODELS_FULFILLED'
export const LOAD_NEW_PRODUCT_MODELS_REJECTED = 'LOAD_NEW_PRODUCT_MODELS_REJECTED'

export const LOAD_PRODUCT_MODELS_BY_ID = 'LOAD_PRODUCT_MODELS_BY_ID'
export const LOAD_PRODUCT_MODELS_BY_ID_PENDING = 'LOAD_PRODUCT_MODELS_BY_ID_PENDING'
export const LOAD_PRODUCT_MODELS_BY_ID_FULFILLED = 'LOAD_PRODUCT_MODELS_BY_ID_FULFILLED'
export const LOAD_PRODUCT_MODELS_BY_ID_REJECTED = 'LOAD_PRODUCT_MODELS_BY_ID_REJECTED'

export const PUT_PRODUCT_MODELS = 'PUT_PRODUCT_MODELS'
export const PUT_PRODUCT_MODELS_PENDING = 'PUT_PRODUCT_MODELS_PENDING'
export const PUT_PRODUCT_MODELS_FULFILLED = 'PUT_PRODUCT_MODELS_FULFILLED'
export const PUT_PRODUCT_MODELS_REJECTED = 'PUT_PRODUCT_MODELS_REJECTED'

export const POST_PRODUCT_MODELS = 'POST_PRODUCT_MODELS'
export const POST_PRODUCT_MODELS_PENDING = 'POST_PRODUCT_MODELS_PENDING'
export const POST_PRODUCT_MODELS_FULFILLED = 'POST_PRODUCT_MODELS_FULFILLED'
export const POST_PRODUCT_MODELS_REJECTED = 'POST_PRODUCT_MODELS_REJECTED'

export const DELETE_PRODUCT_MODELS = 'DELETE_PRODUCT_MODELS'
export const DELETE_PRODUCT_MODELS_PENDING = 'DELETE_PRODUCT_MODELS_PENDING'
export const DELETE_PRODUCT_MODELS_FULFILLED = 'DELETE_PRODUCT_MODELS_FULFILLED'
export const DELETE_PRODUCT_MODELS_REJECTED = 'DELETE_PRODUCT_MODELS_REJECTED'

export const LOAD_ADMIN_PRODUCT_TYPES = 'LOAD_ADMIN_PRODUCT_TYPES'
export const LOAD_ADMIN_PRODUCT_TYPES_PENDING = 'LOAD_ADMIN_PRODUCT_TYPES_PENDING'
export const LOAD_ADMIN_PRODUCT_TYPES_FULFILLED = 'LOAD_ADMIN_PRODUCT_TYPES_FULFILLED'
export const LOAD_ADMIN_PRODUCT_TYPES_REJECTED = 'LOAD_ADMIN_PRODUCT_TYPES_REJECTED'

export const LOAD_NEW_ADMIN_PRODUCT_TYPES = 'LOAD_NEW_ADMIN_PRODUCT_TYPES'
export const LOAD_NEW_ADMIN_PRODUCT_TYPES_PENDING = 'LOAD_NEW_ADMIN_PRODUCT_TYPES_PENDING'
export const LOAD_NEW_ADMIN_PRODUCT_TYPES_FULFILLED = 'LOAD_NEW_ADMIN_PRODUCT_TYPES_FULFILLED'
export const LOAD_NEW_ADMIN_PRODUCT_TYPES_REJECTED = 'LOAD_NEW_ADMIN_PRODUCT_TYPES_REJECTED'

export const LOAD_ADMIN_PRODUCT_TYPES_BY_ID = 'LOAD_ADMIN_PRODUCT_TYPES_BY_ID'
export const LOAD_ADMIN_PRODUCT_TYPES_BY_ID_PENDING = 'LOAD_ADMIN_PRODUCT_TYPES_BY_ID_PENDING'
export const LOAD_ADMIN_PRODUCT_TYPES_BY_ID_FULFILLED = 'LOAD_ADMIN_PRODUCT_TYPES_BY_ID_FULFILLED'
export const LOAD_ADMIN_PRODUCT_TYPES_BY_ID_REJECTED = 'LOAD_ADMIN_PRODUCT_TYPES_BY_ID_REJECTED'

export const PUT_ADMIN_PRODUCT_TYPES = 'PUT_ADMIN_PRODUCT_TYPES'
export const PUT_ADMIN_PRODUCT_TYPES_PENDING = 'PUT_ADMIN_PRODUCT_TYPES_PENDING'
export const PUT_ADMIN_PRODUCT_TYPES_FULFILLED = 'PUT_ADMIN_PRODUCT_TYPES_FULFILLED'
export const PUT_ADMIN_PRODUCT_TYPES_REJECTED = 'PUT_ADMIN_PRODUCT_TYPES_REJECTED'

export const POST_ADMIN_PRODUCT_TYPES = 'POST_ADMIN_PRODUCT_TYPES'
export const POST_ADMIN_PRODUCT_TYPES_PENDING = 'POST_ADMIN_PRODUCT_TYPES_PENDING'
export const POST_ADMIN_PRODUCT_TYPES_FULFILLED = 'POST_ADMIN_PRODUCT_TYPES_FULFILLED'
export const POST_ADMIN_PRODUCT_TYPES_REJECTED = 'POST_ADMIN_PRODUCT_TYPES_REJECTED'

export const DELETE_ADMIN_PRODUCT_TYPES = 'DELETE_ADMIN_PRODUCT_TYPES'
export const DELETE_ADMIN_PRODUCT_TYPES_PENDING = 'DELETE_ADMIN_PRODUCT_TYPES_PENDING'
export const DELETE_ADMIN_PRODUCT_TYPES_FULFILLED = 'DELETE_ADMIN_PRODUCT_TYPES_FULFILLED'
export const DELETE_ADMIN_PRODUCT_TYPES_REJECTED = 'DELETE_ADMIN_PRODUCT_TYPES_REJECTED'

export const LOAD_PRODUCT_MODELS_IMAGES = 'LOAD_PRODUCT_MODELS_IMAGES'
export const LOAD_PRODUCT_MODELS_IMAGES_PENDING = 'LOAD_PRODUCT_MODELS_IMAGES_PENDING'
export const LOAD_PRODUCT_MODELS_IMAGES_FULFILLED = 'LOAD_PRODUCT_MODELS_IMAGES_FULFILLED'
export const LOAD_PRODUCT_MODELS_IMAGES_REJECTED = 'LOAD_PRODUCT_MODELS_IMAGES_REJECTED'

export const LOAD_NEW_PRODUCT_MODELS_IMAGES = 'LOAD_NEW_PRODUCT_MODELS_IMAGES'
export const LOAD_NEW_PRODUCT_MODELS_IMAGES_PENDING = 'LOAD_NEW_PRODUCT_MODELS_IMAGES_PENDING'
export const LOAD_NEW_PRODUCT_MODELS_IMAGES_FULFILLED = 'LOAD_NEW_PRODUCT_MODELS_IMAGES_FULFILLED'
export const LOAD_NEW_PRODUCT_MODELS_IMAGES_REJECTED = 'LOAD_NEW_PRODUCT_MODELS_IMAGES_REJECTED'

export const POST_PRODUCT_MODELS_IMAGES = 'POST_PRODUCT_MODELS_IMAGES'
export const POST_PRODUCT_MODELS_IMAGES_PENDING = 'POST_PRODUCT_MODELS_IMAGES_PENDING'
export const POST_PRODUCT_MODELS_IMAGES_FULFILLED = 'POST_PRODUCT_MODELS_IMAGES_FULFILLED'
export const POST_PRODUCT_MODELS_IMAGES_REJECTED = 'POST_PRODUCT_MODELS_IMAGES_REJECTED'

export const DELETE_PRODUCT_MODELS_IMAGES = 'DELETE_PRODUCT_MODELS_IMAGES'
export const DELETE_PRODUCT_MODELS_IMAGES_PENDING = 'DELETE_PRODUCT_MODELS_IMAGES_PENDING'
export const DELETE_PRODUCT_MODELS_IMAGES_FULFILLED = 'DELETE_PRODUCT_MODELS_IMAGES_FULFILLED'
export const DELETE_PRODUCT_MODELS_IMAGES_REJECTED = 'DELETE_PRODUCT_MODELS_IMAGES_REJECTED'

export const CLEAR_PRODUCT_MODELS_MESSAGES = 'CLEAR_PRODUCT_MODELS_MESSAGES'

export function loadProductModelsFilterOptions() {
  return {
    type: LOAD_PRODUCT_MODELS_FILTER_OPTIONS,
    payload: getProductModelsFilterOptions(),
  }
}

// ---------------------------Variants----------------------------
export function loadProductModelsVariants(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_PRODUCT_MODELS_VARIANTS : LOAD_PRODUCT_MODELS_VARIANTS,
    payload: getProductModelsVariants(queryParams),
  }
}

export function editProductModelsVariants(modelId, variantsId, bodyParams) {
  return {
    type: PUT_PRODUCT_MODELS_VARIANTS,
    payload: updateProductModelsVariantsById(modelId, variantsId, bodyParams),
  }
}

export function createProductModelsVariants(modelId, bodyParams) {
  return {
    type: POST_PRODUCT_MODELS_VARIANTS,
    payload: addProductModelsVariants(modelId, bodyParams),
  }
}

export function removeProductModelsVariants(modelId, variantsId, bodyParams) {
  return {
    type: DELETE_PRODUCT_MODELS_VARIANTS,
    payload: deleteProductModelsVariantsById(modelId, variantsId, bodyParams),
    meta: { variantsId },
  }
}

export function downloadModelVariantsCSV(bodyParams) {
  return {
    type: DOWNLOAD_PRODUCT_MODELS_VARIANTS,
    payload: downloadModelVariants(bodyParams),
  }
}

// ---------------------------Models----------------------------
export function loadProductModels(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_PRODUCT_MODELS : LOAD_PRODUCT_MODELS,
    payload: getProductModels(queryParams),
  }
}

export function loadProductModelsById(queryParams) {
  return {
    type: LOAD_PRODUCT_MODELS_BY_ID,
    payload: getProductModelsById(queryParams),
  }
}

export function createProductModel(bodyParams) {
  return {
    type: POST_PRODUCT_MODELS,
    payload: addProductModels(bodyParams),
  }
}

export function editProductModels(modelId, bodyParams) {
  return {
    type: PUT_PRODUCT_MODELS,
    payload: updateProductModelsById(modelId, bodyParams),
  }
}

export function removeProductModels(modelId) {
  return {
    type: DELETE_PRODUCT_MODELS,
    payload: deleteProductModelsById(modelId),
    meta: { modelId },
  }
}

// ---------------------------Product Types----------------------------
export function loadAdminProductTypes(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_ADMIN_PRODUCT_TYPES : LOAD_ADMIN_PRODUCT_TYPES,
    payload: getAdminProductTypes(queryParams),
  }
}

export function loadAdminProductTypesById(queryParams) {
  return {
    type: LOAD_ADMIN_PRODUCT_TYPES_BY_ID,
    payload: getAdminProductTypesById(queryParams),
  }
}

export function createAdminProductTypes(bodyParams) {
  return {
    type: POST_ADMIN_PRODUCT_TYPES,
    payload: addAdminProductTypes(bodyParams),
  }
}

export function editAdminProductTypes(id, bodyParams) {
  return {
    type: PUT_ADMIN_PRODUCT_TYPES,
    payload: updateAdminProductTypesById(id, bodyParams),
  }
}

export function removeAdminProductTypes(id) {
  return {
    type: DELETE_ADMIN_PRODUCT_TYPES,
    payload: deleteAdminProductTypesById(id),
    meta: { id },
  }
}

// ---------------------------Images----------------------------
export function loadProductModelsImages(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_PRODUCT_MODELS_IMAGES : LOAD_PRODUCT_MODELS_IMAGES,
    payload: getProductModelsImages(queryParams),
  }
}

export function createProductModelsImages(modelId, bodyParams) {
  return {
    type: POST_PRODUCT_MODELS_IMAGES,
    payload: addProductModelsImages(modelId, bodyParams),
  }
}

export function removeProductModelsImages(modelId, id, bodyParams) {
  return {
    type: DELETE_PRODUCT_MODELS_IMAGES,
    payload: deleteProductModelsImagesById(modelId, id, bodyParams),
    meta: { id },
  }
}

export function clearProductModelsMessages() {
  return {
    type: CLEAR_PRODUCT_MODELS_MESSAGES,
  }
}
